import type {FCWithChildren} from 'types';
import {Card} from 'components/card';

export const DefaultContainer: FCWithChildren = ({children}) => (
  <Card level="level3">
    <Card.Content>{children}</Card.Content>
  </Card>
);
